module.exports = __webpack_public_path__ + "static/media/3c.039e791f.png";